import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormViewState } from 'src/app/common/models/form-view-state';
import { RSFAmendment } from 'src/app/components/rsf/rsf';
import { RsfService } from 'src/app/components/rsf/rsf.service';

@Component({
  selector: 'form-history-rsf',
  templateUrl: './form-history-rsf.component.html',
  styleUrls: ['./form-history-rsf.component.scss']
})
export class FormHistoryRsfComponent implements OnChanges {

  @Input() originalBody: any;
  @Input() status?: FormViewState;

  rsfAmendment?: RSFAmendment;

  constructor(public service: RsfService) { }

  ngOnChanges(changes: SimpleChanges): void {
    this.rsfAmendment = this.originalBody?.rsfAmendments?.find((amendment: RSFAmendment) => amendment.active);
  }
}
